import { server } from './server'
import {
    UserApiUrl, DashboardApiUrl, CoursesApiUrl,
    GuidesApiUrl, UserProfileApiUrl, GlobalSearchApiUrl,
    ViewerApiUrl, ViewerSearchApiUrl, AnnotationApiUrl,
    BookmarkApiUrl, ExerciseApiUrl, SelfAssessmentApiUrl,
    PublicApiUrl, TeachersApiUrl,
    EventsApiUrl,
    FaqsApiUrl,
    AboutApiUrl,
    TrackingsApiUrl
} from 'src/index';

export const baseUrlApi = server.rootApi || 'https://dev-contents-viewer-api.devworkbench.it';
export const baseUserUrlApi = `${baseUrlApi}/iam`;
export const baseContentUrlApi = `${baseUrlApi}/content`;
export const baseTeachersUrlApi = `${baseUrlApi}/teachers`;
export const baseAnnotationUrlApi = server.rootAnnotationApi || `${baseUrlApi}/annotation`;
export const baseExerciseUrlApi = `${baseUrlApi}/exercise`;
export const baseSelfAssessmentUrlApi = `${baseUrlApi}/slass`;
export const basePublicUrlApi = `${baseUrlApi}/content`;
export const baseEventsUrlApi = `${baseUrlApi}/events`;
export const baseTrackingsUrlApi = `${baseUrlApi}/trackings`;

export const userApiUrl: UserApiUrl = {
    login: `${baseUserUrlApi}/login`,
    logout: `${baseUserUrlApi}/logout`,
    checklogin: `${baseUserUrlApi}/checklogin`,
    registration: `${baseUserUrlApi}/registration`,
    changePassword: `${baseUserUrlApi}/changePassword`,
    changePasswordWT: `${baseUserUrlApi}/changePasswordWT`,
    saveUserData: `${baseUserUrlApi}/update`,
    resetPassword: `${baseUserUrlApi}/resetPassword`,
};

export const dashboardApiUrl: DashboardApiUrl = {
    coursesInEvidence: `${baseContentUrlApi}/courses/evidence`,
    coursesInProgess: `${baseContentUrlApi}/courses/progress`,
    coursesStudyPath: `${baseContentUrlApi}/courses/studyPath?title=:search`,
};

export const coursesApiUrl: CoursesApiUrl = {
    courses: `${baseContentUrlApi}/courses?title=:search`,
    courseDetail: `${baseContentUrlApi}/course/:uuidCourse`,
    courseModuleContent: `${baseContentUrlApi}/course/:courseId/:moduleId/:contentId`,
    activateCourse: `${baseContentUrlApi}/course/activate`,
    suggestedCourses: `${baseContentUrlApi}/courses/suggested?courseId=:courseId&contentId=:contentId`,
    userSuggested: `${baseContentUrlApi}/courses/userSuggested`,
    startCourse: `${baseContentUrlApi}/course/start/:uuidCourse`,
    trackProgress: `${baseContentUrlApi}/course/trackProgress`,
    requestBadge: `${baseContentUrlApi}/course/requestBadge`,
    unsubscribeCourse: `${baseContentUrlApi}/course/unsubscribe/:uuidCourse?deleteData=:deleteData`,
}

export const teachersApiUrl: TeachersApiUrl = {
    teacherDetail: `${baseTeachersUrlApi}/:id`,
}

export const guidesApiUrl: GuidesApiUrl = {
    guides: `${baseContentUrlApi}/guides?title=:search`,
    courseRelatedGuides: `${baseContentUrlApi}/course/relatedGuides/:uuidCourse`,
}

export const userProfileApiUrl: UserProfileApiUrl = {
    userSkillsGroups: `${baseContentUrlApi}/skillsGroups`,
    userSkillsList: `${baseContentUrlApi}/skills/:skillsGroup`,
}

export const globalSearchApiUrl: GlobalSearchApiUrl = {
    search: `${baseContentUrlApi}/search`,
    botSearch: `${baseContentUrlApi}/botSearch`,
}

export const viewerApiUrl: ViewerApiUrl = {
    getPublication: `${baseContentUrlApi}/publication/:publicationId`,
    getContent: `${baseContentUrlApi}/publication/:publicationId/content/:contentId`,
    viewerSearch: `${baseContentUrlApi}/searchInPub`,
}

export const annotationApiUrl: AnnotationApiUrl = {
    //loadAnnotationsCounts: `${baseAnnotationUrlApi}/loadAnnotationsCounts/info`,
    //loadAnnotationsByVolume: `${baseAnnotationUrlApi}/loadAnnotationsByVolume/volume/:id`,
    getAnnotationsByPublicationIdContentId: `${baseAnnotationUrlApi}/volume/:id/content/:contentId`,
    getAnnotationsByPublicationId: `${baseAnnotationUrlApi}/volume/:id`,
    getAnnotationsByCourseId: `${baseAnnotationUrlApi}/course/:id`,
    //loadAnnotationsByType: `${baseAnnotationUrlApi}/loadAnnotationsByType/:type`,
    deleteAnnotationById: `${baseAnnotationUrlApi}/:annotationId`,
    saveAnnotation: `${baseAnnotationUrlApi}`,
    updateAnnotationById: `${baseAnnotationUrlApi}/:annotationId`,
    //syncAnnotations: `${baseAnnotationUrlApi}/syncAnnotations/annotations`
};

export const bookmarkApiUrl: BookmarkApiUrl = {
    annotation: `${baseAnnotationUrlApi}/annotation/volume/:publicationId?type=bookmark`,
}

export const viewerSearchApiUrl: ViewerSearchApiUrl = {
    content: `${baseContentUrlApi}/content/search?pubId=:publicationId&text=:searchString`,
}

export const exerciseApiUrl: ExerciseApiUrl = {
    saveExerciseExecution: `${baseExerciseUrlApi}/save`,
    getExerciseExecution: `${baseExerciseUrlApi}/course/:courseId/:moduleId/:contentId`,
}

export const selfAssessmentApiUrl: SelfAssessmentApiUrl = {
    getSelfAssessmentSets: `${baseSelfAssessmentUrlApi}/sets`,
    getSelfAssessmentSet: `${baseSelfAssessmentUrlApi}/set/:uuid`,
    saveExecution: `${baseSelfAssessmentUrlApi}/set/:uuid/execution`,
    deleteExecution: `${baseSelfAssessmentUrlApi}/execution/:uuid`,
}

export const publicApiUrl: PublicApiUrl = {
    getPublicCourse: `${basePublicUrlApi}/public/course/:uuidCourse`,
}

export const eventsApiUrl: EventsApiUrl = {
    events: `${baseEventsUrlApi}/search`,
    calendly: `${baseEventsUrlApi}/calendly`,
}

export const faqsApiUrl: FaqsApiUrl = {
    faqs: `${baseEventsUrlApi}/faqs`,
}

export const aboutApiUrl: AboutApiUrl = {
    about: `${baseEventsUrlApi}/about`,
}

export const trackingsApiUrl: TrackingsApiUrl = {
    trackings: `${baseTrackingsUrlApi}`,
}